import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
 
  static targets = ["menu", "frame"]

  static classes = ["open"]
  static values = {
    openClass: { type: String, default: "block" },
    url: String
  }

  connect() {
    this.closeClass = "hidden"
    
    // Close dropdown when clicking outside
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.isOpen()) {
      this.close()
    } else {
      this.open(event)
    }
  }

  // For turbo frames using src and lazy laoding to delay loading till user actually accesses dropdown
  lazy_toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    console.log("SRC check on", this.frameTarget)
    console.log("Has src?", this.frameTarget.hasAttribute('src'))
    console.log("Complete?", this.frameTarget.complete)
    console.log("URL value:", this.urlValue)
    
    // Set the src if not already loaded
    if (!this.frameTarget.hasAttribute('src')) {
      console.log("Setting src", this.urlValue)
      console.log("Setting on", this.frameTarget)
      this.frameTarget.setAttribute('src', this.urlValue)
    } else {
      console.log("Frame already has src attribute")
    }
    
    // Toggle visibility
    console.log("TOOGLE HIDDEN ON", this.menuTarget)
    this.menuTarget.classList.toggle('hidden')
  }

  open(event) {
    // Close any other open dropdowns first
    this.closeAllDropdowns()
    
    // Position the dropdown relative to the trigger button
    if (event && event.currentTarget) {
      this.positionDropdown(event.currentTarget)
    }
    
    const openClass = this.hasOpenClass ? this.openClass : this.openClassValue
    this.menuTarget.classList.remove(this.closeClass)
    this.menuTarget.classList.add(openClass)
    this.menuTarget.setAttribute("aria-hidden", "false")
  }

  close() {
    const openClass = this.hasOpenClass ? this.openClass : this.openClassValue
    this.menuTarget.classList.remove(openClass)
    this.menuTarget.classList.add(this.closeClass)
    this.menuTarget.setAttribute("aria-hidden", "true")
  }

  isOpen() {
    return this.menuTarget.classList.contains(this.hasOpenClass ? this.openClass : this.openClassValue)
  }

  positionDropdown(trigger) {
    const menu = this.menuTarget
    const rect = trigger.getBoundingClientRect()
    const menuRect = menu.getBoundingClientRect()
    
    // Position dropdown below and to the right of the trigger
    menu.style.position = "fixed"
    menu.style.top = `${rect.bottom + 4}px`
    
    // Check if dropdown would go off the right edge of the screen
    const rightEdge = rect.right
    const menuWidth = 256 // w-64 = 16rem = 256px
    
    if (rightEdge - menuWidth < 0) {
      // Position to the left of the trigger if not enough space on the right
      menu.style.left = `${Math.max(8, rect.left - menuWidth + rect.width)}px`
    } else {
      // Position to the right edge of the trigger
      menu.style.left = `${rightEdge - menuWidth}px`
    }
    
    // Ensure dropdown doesn't go below viewport
    const viewportHeight = window.innerHeight
    const menuHeight = menu.offsetHeight || 200 // estimated height
    
    if (rect.bottom + menuHeight + 8 > viewportHeight) {
      // Position above the trigger if not enough space below
      menu.style.top = `${rect.top - menuHeight - 4}px`
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && this.isOpen()) {
      this.close()
    }
  }

  closeAllDropdowns() {
    // Close any other open dropdowns on the page
    document.querySelectorAll('[data-controller*="dropdown"]').forEach(dropdown => {
      const controller = this.application.getControllerForElementAndIdentifier(dropdown, 'dropdown')
      if (controller && controller !== this && controller.isOpen()) {
        controller.close()
      }
    })
  }

  // Method to be called from external triggers
  static openDropdown(dropdownId, triggerElement) {
    const dropdown = document.getElementById(dropdownId)
    if (dropdown) {
      const controller = this.application.getControllerForElementAndIdentifier(dropdown, 'dropdown')
      if (controller) {
        controller.open({ currentTarget: triggerElement })
      }
    }
  }
}